import {
  get_interchange_assets,
  get_interchange_assets_type,
  get_interchange_assets_history,
  get_contract_upgrade_fee_rate,
  new_trade_sure,
  inventory,
  api_SellItem,
} from "@/api";
import {
  conversion,
  typeRate,
  GetItemDuration,
  GetItemName,
  GetItemSkinName,
} from "@/tool";
import { mapMutations, mapState } from "vuex";

import open_sound from "@/assets/audio/unlock.mp3";
import run_sound from "@/assets/audio/roll.mp3";
import win_sound from "@/assets/audio/open.mp3";
import lose_sound from "@/assets/audio/lose.ogg";

import CustomButton from "@/partials/custom_button";

import Button from "@/components/button";
import InteractivePanel from "@/components/interactive_panel";
import Picture from "@/components/picture";
import { CustomBlockTitle } from "@/partials/custom_block_title";
import LuckBox from "@/partials/luck_box";
import Award from "@/components/award";

import exchange_random_accessory_png from "@/assets/images/lucky_item/random_item.png";
import animation from "./components/animation.vue";

import AnimateNumber from "@/components/AnimateNumber/index.vue";

import { Turntable, RewardModal } from "@/components/UI";

export default {
  filters: {
    conversion,
    GetItemDuration,
    GetItemName,
    GetItemSkinName,
  },

  components: {
    "p-custom-block-title": CustomBlockTitle,
    "p-custom-button": CustomButton,
    "p-luckbox": LuckBox,
    "c-button": Button,
    "c-interactive-panel": InteractivePanel,
    "c-picture": Picture,
    "c-award": Award,
    "c-animation": animation,
    "c-RewardModal": RewardModal,
    "c-number": AnimateNumber,
    "c-turntable": Turntable,
  },
  data() {
    return {
      notice_modal_show: false,
      itemHistory: [],
      /** 是否跳过开箱动画 */
      is_jump_case_open_animation: false,

      prizes: [],
      targetData: {
        price: 0,
      },
      upgrade_success_rate: 5,
      prize: {
        flag: false,
        animate: false,
        bSuccess: false,
        showPrize: [{ name: "", price: 0 }],
      },
      price_range: 0,
      modal: {
        flag: false,
      },
      inventory_assets_modal: {
        flag: false,
        search_name: "",
        sort_price: 0,
        categoryId: 1, //当前分类 id
        sub_catetoryId: 0, //当前子分类 ID
        sub_catetory_name: "",
        items: [],
      },
      assets_modal: {
        flag: false,
        search_name: "",
        sort_price: 0,
        categoryId: 99, //当前分类 id
        sub_catetoryId: 0, //当前子分类 ID
        sub_catetory_name: "",
        list_assets_data: {
          categories: [],
          items: [],
        },
      },
      assets_data: {
        flag: false,
        search_name: "",
        sort_price: 0,
        categoryId: 1, //当前分类 id
        sub_catetoryId: 0, //当前子分类 ID
        sub_catetory_name: "",
        list_assets_data: {
          categories: [],
          items: [],
        },
      },
      sounds: [],
      userSetBalance: 0,
      curProb: 5,
      selectedItemIndex: null,
      roll: 0,
      isLotterying: false,
      minRollNum: 1,
      maxRollNum: 0,
      contractUpgradeFeeRate: null,
    };
  },
  computed: {
    ...mapState(["user", "isMute", "GobalInfo"]),
    SliderPercent: {
      get: function () {
        if (this.upgrade_success_rate + this.totalpackPercent > 75)
          this.upgrade_success_rate = 75 - this.totalpackPercent;

        if (this.targetData.price) {
          if (parseFloat(this.getPrice) > this.user.balance) {
            this.upgrade_success_rate = Math.floor(
              (this.user.balance / this.targetData.price) * 100
            );
            return this.upgrade_success_rate;
          }
        }

        return this.upgrade_success_rate;
      },
      set: function (value) {
        if (value + this.totalpackPercent > 75)
          return (this.upgrade_success_rate = 75 - this.totalpackPercent);

        this.upgrade_success_rate = value;
      },
    },
    MaxSliderPercent() {
      var t = 75 - this.totalpackPercent;
      return t < 0 ? 0 : t;
    },
    totalpackPercent() {
      var FRate = Math.round(
        (this.totalpackPrice / this.targetData.price) * 100
      );
      FRate = FRate > 75 ? 75 : FRate;
      return FRate || 0;
    },
    FSuccessRate() {
      var FRate =
        this.upgrade_success_rate +
        Math.round((this.totalpackPrice / this.targetData.price) * 100);
      FRate = FRate > 50 ? 50 : FRate;
      return FRate || 0;
    },
    totalpackPrice() {
      return Math.round(
        this.inventory_assets_modal.items
          .filter((item) => item.active)
          .map((x) => x.price)
          .reduce((a, c) => a + c, 0)
      );
    },
    totalPrice() {
      return this.formatAmount(
        (this.targetData.price * this.upgrade_success_rate) / 100
      );
    },
    upgradeFeeRate() {
      const feeRate =
        this.contractUpgradeFeeRate !== null &&
        this.contractUpgradeFeeRate !== undefined
          ? this.contractUpgradeFeeRate
          : this.GobalInfo.contractPriceRate;
      return Number(feeRate) || 0;
    },
    upgradeFeePrice() {
      return this.formatAmount(this.totalPrice * this.upgradeFeeRate);
    },
    active_assets_list() {
      return this.assets_modal.list_assets_data.items.filter(
        (item) => item.name.indexOf(this.assets_modal.search_name) > -1
      );
    },
    active_inventory_assets_list() {
      return this.inventory_assets_modal.items.filter(
        (item) =>
          item.itemName.indexOf(this.inventory_assets_modal.search_name) > -1
      );
    },
    selected_inventory_assets_list() {
      return this.inventory_assets_modal.items.filter(
        (item) => item.active > 0
      );
    },
  },
  watch: {
    upgrade_success_rate: {
      handler(val) {
        let currentRateNum = Math.round(1000000 * (parseInt(val) / 100));
        this.maxRollNum =
          parseInt(this.minRollNum) + currentRateNum - 1 <= 1000000
            ? Math.round(parseInt(this.minRollNum) + currentRateNum - 1)
            : Math.round(
                parseInt(this.minRollNum) + currentRateNum - 1000000 - 1
              );
        console.log("this.maxRollNum==1", this.maxRollNum);
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    this.is_jump_case_open_animation =
      sessionStorage.getItem("is_jump_case_open_animation") === "true";

    var sounds = {
      open: new Audio(open_sound),
      run: new Audio(run_sound),
      win: new Audio(win_sound),
      lose: new Audio(lose_sound),
    };

    this.sounds = sounds;
    //this.get_assets_type();
    this.getContractUpgradeFeeRate();
    this.get_assets_list(0, 0);
  },

  async mounted() {
    await this.$nextTick();
    //this.updateRandomItem();
  },

  beforeDestroy() {},

  methods: {
    ...mapMutations(["setInfo", "setPayModal", "setloginModal", "setSpinShow"]),
    formatAmount(value) {
      const amount = window.Number(value) || 0;
      return window.Number(amount.toFixed(2));
    },
    async getContractUpgradeFeeRate() {
      try {
        const res = await get_contract_upgrade_fee_rate();
        if (res.data.code === 0) {
          const feeRateData =
            res.data.data && res.data.data.feeRate !== undefined
              ? res.data.data.feeRate
              : res.data.data;
          this.contractUpgradeFeeRate =
            Number(feeRateData) || 0;
        }
      } catch (error) {
        this.contractUpgradeFeeRate = Number(this.GobalInfo.contractPriceRate) || 0;
      }
    },
    minRollNumHandler() {
      if (this.minRollNum < 1) {
        this.minRollNum = 1;
        this.$toast.error("只能输入 1~1000000间的数字");
      }
      if (this.minRollNum > 1000000) {
        this.minRollNum = 1000000;
        this.$toast.error("只能输入 1~1000000间的数字");
      }
      let currentRateNum = Math.round(
        1000000 * (this.upgrade_success_rate / 100)
      );
      this.maxRollNum =
        parseInt(this.minRollNum) + currentRateNum - 1 <= 1000000
          ? Math.round(parseInt(this.minRollNum) + currentRateNum - 1)
          : Math.round(
              parseInt(this.minRollNum) + currentRateNum - 1000000 - 1
            );
      console.log("this.maxRollNum==", this.maxRollNum);
    },
    maxRollNumHandler() {
      if (this.maxRollNum < 1) {
        this.maxRollNum = 1;
        this.$toast.error("只能输入 1~1000000间的数字");
      }
      if (this.maxRollNum > 1000000) {
        this.maxRollNum = 1000000;
        this.$toast.error("只能输入 1~1000000间的数字");
      }
      let currentRateNum = Math.round(
        1000000 * (this.upgrade_success_rate / 100)
      );
      this.minRollNum =
        parseInt(this.maxRollNum) - currentRateNum >= 0
          ? Math.round(parseInt(this.maxRollNum) - currentRateNum + 1)
          : Math.round(
              1000000 - Math.abs(parseInt(this.maxRollNum) - currentRateNum) + 1
            );
      console.log("minRollNum==", this.minRollNum);
    },
    onUseBalanceInputChange(e) {
      var val = e.target.value;
      var setNumber = parseFloat(
        val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, "$1")
      );
      console.log("test" + setNumber);
      var rate = (setNumber / this.targetData.price) * 100;
      console.log("1test" + rate);
      this.upgrade_success_rate = rate;
    },

    /** 跳过开箱动画 切换  */
    async toggle_is_jump_case_open_animation() {
      return;
      sessionStorage.setItem(
        "is_jump_case_open_animation",
        String(this.is_jump_case_open_animation)
      );
    },

    playAudio() {
      if (!this.isMute && !this.is_jump_case_open_animation) {
        this.sounds["open"].currentTime = 0;
        this.sounds["open"].play();
        this.sounds["run"].currentTime = 0;
        this.sounds["run"].playbackRate = 1.8;
        this.sounds["run"].play();
      }
    },
    stopAudio() {
      this.sounds["run"].pause();
    },
    startCallBack() {
      this.assets_modal.flag = true;
    },
    async endCallBack() {
      this.prize.flag = true;
      this.prize.animate = false;

      this.$refs.upgrade_reward_ui.reset();

      this.prize.showPrize.forEach((item, index) => {
        this.$refs.upgrade_reward_ui.pushItem(
          item.name,
          item.mSerial,
          item.imgUrl,
          item.rarity,
          item.price,
          this.roll
        );
      });

      await this.$nextTick();

      if (!this.isMute) {
        this.stopAudio();
        if (this.prize.bSuccess) {
          this.sounds["win"].currentTime = 0;
          this.sounds["win"].play();
        } else {
          this.sounds["lose"].currentTime = 0;
          this.sounds["lose"].play();
        }
      }

      this.$refs.upgrade_reward_ui.show();

      this.get_interchange_assets_history(this.targetData.id);
      this.isLotterying = false;
    },
    on_slider_change() {
      this.updateRandomItem();
    },
    search_subcate(name, sub_cat) {
      this.assets_modal.sub_catetoryId = sub_cat;
      if (name === "不限") this.assets_modal.sub_catetory_name = "";
      else this.assets_modal.sub_catetory_name = name;
    },
    tipsShow() {
      return this.$toast.info(
        "您将会随机获得一件饰品<br/>并有机会额外获得一件心仪的饰品~<br/>每次概率为相互独立事件<br/>例如:50% 的概率连续升级 2 次，并不代表这有 100% 的机会"
      );
    },
    updateRandomItem() {
      let itemcount = parseInt(Math.round(this.upgrade_success_rate / 10));
      if (itemcount == 0) itemcount = 1;

      const prizes = [];

      for (var i = 0; i < 10; i++) {
        if (i < itemcount && this.targetData.name) {
          prizes.push({
            id: i,
            name: this.targetData.name,
            itempic: this.targetData.imgUrl,
            rarity: this.targetData.rarity,
          });
        } else {
          prizes.push({
            id: i,
            name: "随机饰品",
            itempic: exchange_random_accessory_png,
            rarity: 1,
          });
        }
      }

      this.prizes = prizes.sort(() => Math.random() - 0.5);
    },
    select_inventory_item(item) {
      if (item.active) return (item.active = false);

      item.active = true;
    },
    async getInventoryAssets() {
      var respone = await inventory({ current: 1, size: 9999 });

      this.inventory_assets_modal.items = respone.data.data.data
        .filter((_) => _.lockType == 0)
        .slice();
      console.log(this.inventory_assets_modal.items);
    },
    sortInvetoryAssets() {
      this.inventory_assets_modal.sort_price =
        this.inventory_assets_modal.sort_price == 0 ? 1 : 0;

      if (this.inventory_assets_modal.sort_price == 1) {
        this.inventory_assets_modal.items.sort(function (a, b) {
          return a.price - b.price;
        });
      } else {
        this.inventory_assets_modal.items.sort(function (a, b) {
          return b.price - a.price;
        });
      }
    },
    async openInventoryModal() {
      if (!this.user.nickname) {
        return this.setloginModal(true);
      }

      if (this.inventory_assets_modal.items.length <= 0) {
        await this.getInventoryAssets();
      }

      this.inventory_assets_modal.flag = true;
    },
    async get_interchange_assets_history(id) {
      var respone = await get_interchange_assets_history({
        id: id,
        pageIndex: 1,
        pageSize: 21,
      });

      this.itemHistory = respone.data.data;
    },
    async get_assets_type() {
      var respone = await get_interchange_assets_type({
        cat: this.assets_modal.categoryId,
      });

      this.assets_modal.list_assets_data.categories = respone.data.data;
      this.assets_modal.list_assets_data.categories.unshift({
        name: "全部",
        imgUrl: "",
        parentName: null,
        sort: 1,
        id: 0,
        createTime: "",
        updatedTime: "",
      });
    },
    /** 获取初始列表 */
    async get_assets_list(type, sort) {
      this.assets_modal.sort_price = sort;
      //this.assets_modal.categoryId = type;
      this.assets_modal.search_name = "";
      this.search_subcate("", 0);

      var minprice = 0;
      var maxprice = 9999999;

      switch (this.price_range) {
        case 1:
          minprice = 0;
          maxprice = 50;
          break;
        case 2:
          minprice = 50;
          maxprice = 200;
          break;
        case 3:
          minprice = 200;
          maxprice = 1000;
          break;
        case 4:
          minprice = 1000;
          maxprice = 2000;
          break;
        case 5:
          minprice = 2000;
          maxprice = 9999999;
          break;
        default:
          minprice = 0;
          maxprice = 9999999;
          break;
      }

      var respone = await get_interchange_assets({
        cat: this.assets_modal.categoryId,
        size: 999999,
        minprice,
        maxprice,
      });
      this.setSpinShow(false);
      this.assets_modal.list_assets_data.items = respone.data.data;

      if (sort == 1) {
        this.assets_modal.list_assets_data.items.sort(function (a, b) {
          return a.price - b.price;
        });
      } else {
        this.assets_modal.list_assets_data.items.sort(function (a, b) {
          return b.price - a.price;
        });
      }
    },
    selected_assets(item, index) {
      this.targetData = item;
      this.updateRandomItem(); //更新饰品
      this.get_interchange_assets_history(item.id);
      this.assets_modal.flag = false;
      this.selectedItemIndex = index;
      console.log("this.selectedItemIndex==", this.selectedItemIndex);
    },
    selProb(prob) {
      switch (prob) {
        case 1:
        case 5:
        case 10:
        case 50:
          this.curProb = prob;
          this.upgrade_success_rate = prob;
          break;
        default:
          this.curProb = 5;
          this.upgrade_success_rate = 5;
      }
    },
    async send_trade_api() {
      this.roll = 0;

      if (!this.user.nickname) {
        return this.setloginModal(true);
      }

      if (!this.targetData.name) {
        return this.$toast.error("请先选择饰品");
      }

      let amount = (
        (this.targetData.price * this.upgrade_success_rate) /
        100
      ).toFixed(2);

      if (amount > this.user.balance + this.user.recycles) {
        this.$toast.error("余额不足，请充值后重试");
        this.setPayModal(true);
        return;
      }

      if (amount < 2) {
        return this.$toast.error("升级最低消耗不得低于2");
      }

      // if (this.upgrade_success_rate < 5) {
      // 	return this.$toast.error('总成功率不得低于5%');
      // }

      // if (this.prize.animate) return;

      // this.prize.animate = true;

      var InvItems = this.inventory_assets_modal.items
        .filter((item) => item.active)
        .map((x) => x.mSerial);

      this.isLotterying = true;

      let res = (
        await new_trade_sure({
          itemId: this.targetData.id,
          InvItemMSerial: InvItems,
          percent: this.FSuccessRate,
        })
      ).data;

      if (res.code === 0) {
        this.setInfo();
        this.getInventoryAssets();

        // var temparr = this.prizes.slice();
        // temparr = temparr.sort(() => Math.random() - 0.5);

        let prizeArray = [];

        prizeArray.push(res.data.item);

        this.prize.bSuccess = res.data.bSuccess; //用以判断是否成功
        this.prize.showPrize = prizeArray;

        this.playAudio();
        // this.onStartTurntable(res.data.bSuccess);
        // this.$refs.turntable.onStartTurntable(res.data.bSuccess);
        this.roll = this.$refs.turntable.onStartTurntable(res.data.bSuccess);

        if (this.is_jump_case_open_animation) {
          this.endCallBack();
        } else {
          if (res.data.bSuccess) {
            this.$refs.runbox.start(this.targetData.name, this.prizes);
          } else {
            this.$refs.runbox.start("随机饰品", this.prizes);
          }
        }
      } else {
        this.$toast.error(res.msg);

        if (res.msg.indexOf("充值") > -1) {
          this.setPayModal(true);
        }
      }
    },
    /** 开箱奖品折现 */
    async case_opened_awards_discount() {
      const awards_Serial = this.prize.showPrize.map((award) => award.mSerial);

      const awards_discount_response = await api_SellItem({
        lstmSerial: awards_Serial,
      });

      // 折现失败
      if (awards_discount_response.data.code !== 0) {
        this.$toast.error(awards_discount_response.data.msg);
        return;
      }

      this.prize.flag = false;

      this.$toast.success(awards_discount_response.data.msg);

      // 更新用户信息
      this.$store.commit("setInfo");
    },
  },
};
